import React from 'react';
import { Grid2 } from '@mui/material';
import PaidLeaveChart from './PaidLeaveChart';
import SickDaysChart from './SickDaysChart';

const MyLeavesCharts = () => {
  return (
    <Grid2 container spacing={3}>
      <Grid2 size={{ xs: 12, sm: 6 }}>
        <PaidLeaveChart />
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 6 }}>
        <SickDaysChart />
      </Grid2>
    </Grid2>
  );
};

export default MyLeavesCharts;
